import closeModalAction from 'modules/modal/actions/close'
import { MODAL_DOMAIN } from 'modules/modal/constants/index.cjs'
import { getCurrentModalSelect } from 'modules/modal/selectors'
import { updateLegacyReduxAction } from 'modules/redux/actions/legacy/update'

/**
 * Resets the DomainNew to null.
 * @param  {string} id
 * @param  {Object} [data={}]
 * @returns {Function}
 */
function openModalAction (id, data = {}) {
  return (dispatch, getState) => {
    const path = MODAL_DOMAIN
    // If a modal is already opened, close it
    const current = getCurrentModalSelect(getState())
    if (current) {
      dispatch(closeModalAction())
    }
    const value = {
      current: id,
      data
    }
    // If the user is editing, no-op
    dispatch(
      updateLegacyReduxAction({
        path,
        value
      })
    )
  }
}

export default openModalAction
